module.exports = __webpack_public_path__ + "img/uplaod.bc41a247.png";